import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  prefix = "/eshop_backend/message";
  constructor(private http: HttpClient) { }
  getReceiveSettingList() {
    return this.http.get<RequestModel>(this.prefix + '/receive/list');
  }
  editReceiveSetting(id: any) {
    return this.http.get<RequestModel>(this.prefix + `/receive/edit/${id}`);
  }
  getMessageList(params:any){
    return this.http.get<RequestModel>(this.prefix + `/page`,{params});
  }
  setRead(params:any){
    return this.http.post<RequestModel>(this.prefix + `/read`,params);
  }
  getUnReadNumber(){
    return this.http.get<RequestModel>(this.prefix + `/unRead`);
  }

}
